import React, { FC, memo, HTMLAttributes } from "react";
import { Flex as FlexUI } from "@evergis/ui";

export const Flex: FC<HTMLAttributes<HTMLDivElement>> = memo(({ children, ...rest }) => (
  <FlexUI {...rest}>{children}</FlexUI>
));
